module.exports = __webpack_public_path__ + "static/media/Get in touch-amico.94dfa44c.svg";